module.exports = __webpack_public_path__ + "img/daizy_construction.1d61cc77.jpg";